import React from 'react'
import { Link } from 'react-router-dom'
import {
    Button,
    Drawer,
    Grid,
    Icon,
    Pagination,
} from '@softwaredev_cegeka/stix-core'
import { authenticatedUserStore } from 'src/stores'
import { SupplierTable } from 'src/components/EntityTable'
import { AuthApi } from 'src/api/authApi'

class SupplierRoute extends React.Component {
    state = {
        suppliers: [...Array(25)].map(item => ({})),
        selectedSupplier: {},
        page: 1,
        totalPages: 1,
        totalElements: 1,
        loading: false,
    }

    authClient = new AuthApi(authenticatedUserStore.authToken)

    componentDidMount() {
        this.fetchAndStoreSuppliers()
    }

    componentWillUnmount() {
        this.authClient.cancelRequest()
    }

    rowSelectHandler = async (selectObj, setDrawerState) => {
        this.setState({
            selectedSupplier: selectObj.row.original,
        }).then(setDrawerState(true))
    }

    fetchAndStoreSuppliers = () => {
        this.setState({ loading: true })
        this.authClient.fetchSuppliers().then(response => {
            this.setState({
                suppliers: response?.data?.results,
                totalPages: response?.data?._page.total_pages,
                totalElements: response?.data?._page.total_elements,
                loading: false,
            })
        })
    }

    handlePageChange = page => {
        this.setState({
            page: page,
        })
    }

    render() {
        return (
            <div className="entity-drawer">
                <Drawer
                    type="fixed"
                    panelTitle={this.state.selectedSupplier.name}
                    panelContent={null}
                >
                    <Grid.Container>
                        <div className={'page-header'}>
                            <h1>Suppliers overview</h1>
                            <Link
                                to={{
                                    pathname: '/suppliers',
                                }}
                            >
                                <Button variant="secondary">
                                    <Icon icon="add" />
                                    <span>Create supplier</span>
                                </Button>
                            </Link>
                        </div>

                        <Drawer.Context.Consumer>
                            {({ setDrawerState }) => (
                                <SupplierTable
                                    suppliers={this.state.suppliers}
                                    loading={this.state.loading}
                                    rowSelectHandler={selectObj =>
                                        this.rowSelectHandler(
                                            selectObj,
                                            setDrawerState
                                        )
                                    }
                                />
                            )}
                        </Drawer.Context.Consumer>

                        <div className="pagination-wrapper">
                            <Pagination
                                lastPage={this.state.totalPages}
                                currentPage={this.state.page}
                                onClick={
                                    this.state.loading
                                        ? () => {}
                                        : this.handlePageChange
                                }
                            />
                        </div>
                    </Grid.Container>
                </Drawer>
            </div>
        )
    }
}

export default SupplierRoute
